import { createForm, createPrimitiveField, emailValidator, requiredValidator } from '@adv-frontend/form-kit';
import {
    factoryGetErrorMessage,
    INVALID_EMAIL_FORMAT_CODE,
    INVALID_EMAIL_FORMAT_MESSAGE,
    type InvalidEmailValidationError,
    VALUE_IS_REQUIRED_CODE,
    VALUE_IS_REQUIRED_MESSAGE,
    type ValueIsRequiredValidationError,
} from '#shared/lib/form';

type EmailAuthFieldError = ValueIsRequiredValidationError | InvalidEmailValidationError;

export const EMAIL_AUTH_FORM_ID = 'email-auth-form';

export const emailAuthFieldGetErrorMessage = factoryGetErrorMessage<EmailAuthFieldError>({
    [VALUE_IS_REQUIRED_CODE]: VALUE_IS_REQUIRED_MESSAGE,
    [INVALID_EMAIL_FORMAT_CODE]: INVALID_EMAIL_FORMAT_MESSAGE,
});

export const emailAuthForm = createForm({
    name: 'EmailAuthForm',
    context: (context: { onSubmit: (email: string) => Promise<void> }) => {
        return { form: context };
    },
    fields: {
        email: createPrimitiveField({
            defaultValue: '',
            validators: (createValidators) =>
                createValidators<EmailAuthFieldError>({
                    onSubmit: [requiredValidator(VALUE_IS_REQUIRED_CODE), emailValidator(INVALID_EMAIL_FORMAT_CODE)],
                }),
        }),
    },
    onSubmit: async ({ email }, formApi) => {
        await formApi.getContext().onSubmit(email.trim());
    },
});
